import {
  Condition,
  ConditionExpression,
  ConditionGroup,
  NestedConditionExpression,
  Ref,
} from '@repo/sdk/models/components';

export const extractConditionRefs = (condition: Condition): Ref[] => {
  return condition.ref ? [condition.ref] : [];
};

export const extractConditionGroupRefs = (conditionGroup: ConditionGroup): Ref[] => {
  const refs: Ref[] = [];

  conditionGroup.conditions?.forEach((condition) => {
    refs.push(...extractConditionRefs(condition));
  });

  return refs;
};

export const extractNestedExpressionRefs = (nestedExpression: NestedConditionExpression): Ref[] => {
  const refs: Ref[] = [];

  nestedExpression.groups?.forEach((group) => {
    refs.push(...extractConditionGroupRefs(group));
  });

  return refs;
};

export const extractConditionExpressionRefs = (expression: ConditionExpression): Ref[] => {
  const refs: Ref[] = [];

  if (expression.condition) {
    refs.push(...extractConditionRefs(expression.condition));
  }

  if (expression.conditionGroup) {
    refs.push(...extractConditionGroupRefs(expression.conditionGroup));
  }

  if (expression.nestedExpression) {
    refs.push(...extractNestedExpressionRefs(expression.nestedExpression));
  }

  return refs;
};
